var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientImgBottom2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1920 747",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1920V747H0V0Z",
    fill: "url(#paint0_linear_1390_4143)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1390_4143",
    x1: 960,
    y1: -62,
    x2: 960,
    y2: 712.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000039",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#000039"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientImgBottom2);
export default __webpack_public_path__ + "static/media/gradient_img_bottom_2.59f226c90ac85bf622a32a90e12214ab.svg";
export { ForwardRef as ReactComponent };